import { render } from "./lista.vue?vue&type=template&id=877577f0"
import script from "./lista.vue?vue&type=script&lang=js"
export * from "./lista.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__